import { AppPlatform, PushNotificationEventInput, PushNotificationEventType } from '@ocx/graphql';
import { CapacitorPlatform, getDevicePlatform } from '@ocx/utils-device';

import { PushNotificationEvent, PushNotificationEventWithDeliveryId } from './push-notification-events.types';

const platformMap: Record<CapacitorPlatform, AppPlatform> = {
  ios: AppPlatform.Ios,
  android: AppPlatform.Android,
  web: AppPlatform.Web,
};

const eventTypeMap: Record<PushNotificationEvent['event_type'], PushNotificationEventType> = {
  notification_received: PushNotificationEventType.Received,
  notification_blocked: PushNotificationEventType.Blocked,
  notification_tapped: PushNotificationEventType.Tapped,
  notification_link_opened: PushNotificationEventType.LinkOpened,
};

export const mapPushNotificationEventToRecordPushNotificationEventInput = (
  event: PushNotificationEventWithDeliveryId,
): PushNotificationEventInput => {
  return {
    deliveryId: event.delivery_id,
    eventType: eventTypeMap[event.event_type],
    occurredAt: new Date(event.occurred_at),
    platform: platformMap[getDevicePlatform()],
  };
};
